'use client';

import ClientOnly from './ClientOnly';
import { AuthProvider } from '@/contexts/AuthContext';

interface ClientAuthProviderProps {
  children: React.ReactNode;
}

export default function ClientAuthProvider({ children }: ClientAuthProviderProps) {
  return (
    <ClientOnly fallback={<div suppressHydrationWarning>{children}</div>}>
      <AuthProvider>{children}</AuthProvider>
    </ClientOnly>
  );
}
